import { render, staticRenderFns } from "./common-header.vue?vue&type=template&id=b02a88a6&scoped=true"
import script from "./common-header.vue?vue&type=script&lang=js"
export * from "./common-header.vue?vue&type=script&lang=js"
import style0 from "./common-header.vue?vue&type=style&index=0&id=b02a88a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02a88a6",
  null
  
)

export default component.exports